import React, { useState } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { Grid } from '@material-ui/core';

import { FetchError } from '../../../common/api/api';
import AppSnackbar from '../../../common/AppSnackbar';
import { useUserContext } from '../../../user/User.context';
import AdminToDoCard from '../../admin-dashboard/AdminToDoCard';
import { DashboardCardProps } from '../Dashboard.interface';
import DashboardDocumentCard from './DashboardDocumentCard';
import DashboardProductCard from './DashboardProductCard';

const DashboardAssignedTab: React.FC = () => {
  const { user } = useUserContext();
  const [search = ''] = useQueryParam('search', StringParam);
  const [error, setError] = useState<FetchError | undefined>();

  const cardProps: DashboardCardProps = {
    search,
    user: user!,
    onError: (error: FetchError) => setError(error)
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <DashboardDocumentCard {...cardProps} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardProductCard {...cardProps} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdminToDoCard />
          </Grid>
        </Grid>
      </Grid>
      <AppSnackbar
        severity='error'
        open={!!error}
        onClose={() => setError(undefined)}
      >
        {error?.message}
      </AppSnackbar>
    </Grid>
  );
};
export default DashboardAssignedTab;
